import { Text } from '@thanx/uikit/text'
import React from 'react'

type Props = {
  name: string
}

const ListCardTitle: React.FC<Props> = React.memo(({ name }) => (
  <Text.BodyText3 bold className="m-0">
    {name}
  </Text.BodyText3>
))

ListCardTitle.displayName = 'ListCardTitle'

export default ListCardTitle
